













































import { Component, Vue, Prop , Watch } from 'vue-property-decorator';
import CityList from '@/components/common/citylist/CityList.vue';
@Component({
    name: 'ToolBar',
    components: {
        CityList,
    },

})
export default class ToolBar extends Vue {
  @Prop() public clickItem: any ;
  @Prop() public cityItemClick: any ;
  @Prop() public cityListName: any ;
  @Prop() private toolbarDatas: any;

  private cityName: any = this.cityListName;
  private cityArrowFlag: any = false;
  private streeIndex: any = -1;
  private isShowCityList: any = false;

  @Watch('cityListName')
  private change(val: any) {
      this.cityName = this.cityListName;
  }


  // 城市列表一级菜单点击
  private cityListClick() {
      this.cityArrowFlag = !this.cityArrowFlag;
      this.isShowCityList = !this.isShowCityList;
  }
  // 关闭城市列表
  private  closeCityList() {
      this.cityArrowFlag = false;
      this.isShowCityList = false;
  }
  // 城市列表内的城市/省份点击
  private cityClickEmit(val: any) {
      this.cityArrowFlag = false;
      this.isShowCityList = false;
      if (val) {
          this.cityName = val.name;
          this.cityItemClick(val);
      } else {
          this.cityName = '全国';
          this.cityItemClick();
      }
  }
  // 一级菜单点击
  private firstMenuClick(item: any) {
      if (item.selectable && (item.key === 'streetBar' || item.key === 'realtime-traffic')) {return; }
      item.selected = !item.selected;
      if (item.children && item.children.length || item.key === 'cityList') {return; }
      this.clickItem(item);

  }
  // 二级菜单点击
  private secondMenuClick(ele: any , eleIndex: any , item: any) {
      if (item.key === 'streetBar') {
          this.streetItemClick(ele, eleIndex, item);
      }
      if (item.key === 'toolBox') {
          this.toolBoxItemClick(ele, item);
      }

  }
  // 街景二级菜单点击
    private streetItemClick(ele: any , eleIndex: any , item: any) {
        if (this.streeIndex === eleIndex ) {
            ele.selected = !ele.selected;
        } else {
            this.toolbarDatas.forEach((item: any) => {
                if (item.children) {
                    item.children.forEach((ele: any) => {
                        ele.selected = false;
                    });
                }
            });
            ele.selected = true;
        }
        this.streeIndex = eleIndex;
        this.clickItem(ele);
    }
  // 工具箱二级菜单点击
  private toolBoxItemClick(ele: any , item: any) {
      item.selected = false;
      this.clickItem(ele);
  }

  private created() {

  }


}
